export type Skill = {
	key: string;
	text: string;
};

export const frontEndSkills: Skill[] = [
	{ key: "front end skill 1", text: "TypeScript" },
	{ key: "front end skill 2", text: "React (w/ hooks)" },
	{ key: "front end skill 3", text: "Redux (w/ hooks)" },
	{ key: "front end skill 4", text: "GatsbyJS" },
	{ key: "front end skill 5", text: "Styled Components" },
	{ key: "front end skill 6", text: "React Spring" },
	{ key: "front end skill 7", text: "Recharts" },
	{ key: "front end skill 8", text: "React ParticlesJS" },
	{ key: "front end skill 9", text: "GreenSock Animation Platform" },
	{ key: "front end skill 10", text: "jQuery" },
];

export const backEndSkills: Skill[] = [
	{ key: "back end skill 1", text: "Hapi" },
	{ key: "back end skill 2", text: "Prisma" },
	{ key: "back end skill 3", text: "PostgreSQL" },
	{ key: "back end skill 4", text: "Django REST Framework" },
	{ key: "back end skill 5", text: "Ruby on Rails" },
];

export const testingSkills: Skill[] = [
	{ key: "testing skill 1", text: "Jest" },
	{ key: "testing skill 2", text: "React Testing Library" },
	{ key: "testing skill 3", text: "Cypress" },
];

export const designSkills: Skill[] = [{ key: "design skill 1", text: "Figma" }];
